// @ts-nocheck
import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL } from "../../utils/code";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { setLoading, setProjects, setUser } from "../reducer/projectSlice";

const axiosInstance = axios.create({
  baseURL: BASE_URL, // Replace with your API's base URL
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true, // Allow cookies from cross-origin backend
});

axiosInstance.interceptors.response.use(
  (response) => response, // If the response is OK, return it
  (error) => {
    if (error.response && error.response.status === 401) {
      // Log out the user (clear localStorage/sessionStorage, etc.)
      localStorage.removeItem("token");

      window.location.href = "/auth/login";

      return Promise.reject(error);
    }
    return Promise.reject(error); // Reject other errors normally
  }
);

export const fetchProjects = createAsyncThunk(
  "fetchProjects",
  async ({ page = 1 }, { dispatch }) => {
    try {
      dispatch(
        setLoading({
          code: "fetchProjects",
          loading: true,
        })
      );
      const res = await axiosInstance.get(
        `${BASE_URL}/api/projects?page=${page}`
        // getHeaders()
      );

      dispatch(
        setLoading({
          code: "fetchProjects",
          loading: false,
        })
      );

      if (res.data.success) {
        dispatch(setProjects(res.data));
      }

      return res;
    } catch (error) {
      dispatch(
        setLoading({
          code: "fetchProjects",
          loading: false,
        })
      );

      toast.error(error.response.data.message);
    }
  }
);

export const createProjectAction = createAsyncThunk(
  "createProjectAction",
  async ({ setButtonLoading, ...data }, { dispatch }) => {
    try {
      setButtonLoading(true);
      const res = await axiosInstance.post(
        `${BASE_URL}/api/projects/create`,
        {
          ...data,
        }
        // getHeaders()
      );

      setButtonLoading(false);
      if (res.data.success) {
        toast.success("Project created successfully.");
        await dispatch(fetchProjects({}));
        return {
          success: true,
        };
      }

      return res;
    } catch (error) {
      setButtonLoading(false);
      toast.error(error.response.data.message);
    }
  }
);

export const updateProjectAction = createAsyncThunk(
  "updateProjectAction",
  async ({ id, ...data }, { dispatch }) => {
    try {
      const res = await axiosInstance.patch(
        `${BASE_URL}/api/projects/${id}`,
        {
          ...data,
        }
        // getHeaders()
      );

      if (res.data.success) {
        toast.success("Project updated successfully.");
        await dispatch(fetchProjects({}));
        return {
          success: true,
        };
      }

      return res;
    } catch (error) {
      toast.error(error.response.data.message);
    }
  }
);

export const fetchSectionsByProject = createAsyncThunk(
  "sections/fetchByProject",
  async (projectId, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${BASE_URL}/api/projects/sections/${projectId}`
      );
      return response.data.sections;
    } catch (error) {
      return rejectWithValue(
        error.response.data.message || "Failed to fetch sections"
      );
    }
  }
);

export const fetchRoomsByProject = createAsyncThunk(
  "sections/fetchRoomsByProject",
  async (projectId, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${BASE_URL}/api/projects/rooms/${projectId}`
      );
      return response.data.rooms;
    } catch (error) {
      return rejectWithValue(
        error.response.data.message || "Failed to fetch rooms"
      );
    }
  }
);

export const fetchTouchesByProject = createAsyncThunk(
  "sections/fetchTouchesByProject",
  async (projectId, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${BASE_URL}/api/projects/touches/${projectId}`
      );
      return response.data.touches;
    } catch (error) {
      return rejectWithValue(
        error.response.data.message || "Failed to fetch touches"
      );
    }
  }
);

export const fetchTouchByTouchId = createAsyncThunk(
  "sections/fetchTouchByTouchId",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${BASE_URL}/api/projects/touches/design/${id}`
      );
      return response.data.touche;
    } catch (error) {
      return rejectWithValue(
        error.response.data.message || "Failed to fetch touche"
      );
    }
  }
);

export const createSection = createAsyncThunk(
  "sections/createSection",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const res = await axiosInstance.post(
        `${BASE_URL}/api/projects/sections`,
        {
          ...data,
        }
        // getHeaders()
      );
      if (res.data.success) {
        toast.success("Section created successfully.");
        await dispatch(fetchSectionsByProject(data?.projectId));
      }

      return res;
    } catch (error) {
      return rejectWithValue(
        error.response.data.message || "Failed to fetch sections"
      );
    }
  }
);

export const createRoom = createAsyncThunk(
  "sections/createRoom",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const res = await axiosInstance.post(
        `${BASE_URL}/api/projects/rooms`,
        {
          ...data,
        }
        // getHeaders()
      );
      if (res.data.success) {
        toast.success("Room created successfully.");
        await dispatch(fetchRoomsByProject(data?.projectId));
      }

      return res;
    } catch (error) {
      return rejectWithValue(
        error.response.data.message || "Failed to fetch rooms"
      );
    }
  }
);

export const createTouch = createAsyncThunk(
  "sections/createTouch",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const res = await axiosInstance.post(
        `${BASE_URL}/api/projects/touches`,
        {
          ...data,
        }
        // getHeaders()
      );
      if (res.data.success) {
        toast.success("Touch created successfully.");
        await dispatch(fetchTouchesByProject(data?.projectId));
      }

      return res;
    } catch (error) {
      return rejectWithValue(
        error.response.data.message || "Failed to fetch touches"
      );
    }
  }
);

export const saveTouch = createAsyncThunk(
  "sections/saveTouch",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const res = await axiosInstance.put(
        `${BASE_URL}/api/projects/touches`,
        {
          ...data,
        }
        // getHeaders()
      );
      if (res.data.success) {
        toast.success(res?.data?.message);
        return res?.data;
      }

      return res;
    } catch (error) {
      return rejectWithValue(
        error.response.data.message || "Failed to save touches"
      );
    }
  }
);

export const deleteProjectAction = createAsyncThunk(
  "deleteProjectAction",
  async ({ id }, { dispatch }) => {
    try {
      dispatch(
        setLoading({
          code: "deleteProjectAction",
          loading: true,
        })
      );
      const res = await axiosInstance.delete(`${BASE_URL}/api/projects/${id}`);

      dispatch(
        setLoading({
          code: "deleteProjectAction",
          loading: false,
        })
      );
      if (res.data.success) {
        toast.success("Project deleted successfully.");
        await dispatch(fetchProjects({}));
      }

      return res;
    } catch (error) {
      dispatch(
        setLoading({
          code: "deleteProjectAction",
          loading: false,
        })
      );
      toast.error(error.response.data.message);
    }
  }
);

export const deleteSectionAction = createAsyncThunk(
  "deleteSectionAction",
  async ({ id, projectId }, { dispatch }) => {
    try {
      dispatch(
        setLoading({
          code: "deleteSectionAction",
          loading: true,
        })
      );
      const res = await axiosInstance.delete(
        `${BASE_URL}/api/projects/sections/${id}`
      );

      dispatch(
        setLoading({
          code: "deleteSectionAction",
          loading: false,
        })
      );
      if (res.data.success) {
        toast.success("Section deleted successfully.");
        await dispatch(fetchSectionsByProject(projectId));
        await dispatch(fetchRoomsByProject(projectId));
        await dispatch(fetchTouchesByProject(projectId));
      }

      return res;
    } catch (error) {
      dispatch(
        setLoading({
          code: "deleteSectionAction",
          loading: false,
        })
      );
      toast.error(error.response.data.message);
    }
  }
);

export const deleteRoomAction = createAsyncThunk(
  "deleteRoomAction",
  async ({ id, projectId }, { dispatch }) => {
    try {
      dispatch(
        setLoading({
          code: "deleteRoomAction",
          loading: true,
        })
      );
      const res = await axiosInstance.delete(
        `${BASE_URL}/api/projects/rooms/${id}`
      );

      dispatch(
        setLoading({
          code: "deleteRoomAction",
          loading: false,
        })
      );
      if (res.data.success) {
        toast.success("Room deleted successfully.");
        await dispatch(fetchSectionsByProject(projectId));
        await dispatch(fetchRoomsByProject(projectId));
        await dispatch(fetchTouchesByProject(projectId));
      }

      return res;
    } catch (error) {
      dispatch(
        setLoading({
          code: "deleteRoomAction",
          loading: false,
        })
      );
      toast.error(error.response.data.message);
    }
  }
);

export const deleteTouchAction = createAsyncThunk(
  "deleteTouchAction",
  async ({ id, projectId }, { dispatch }) => {
    try {
      dispatch(
        setLoading({
          code: "deleteTouchAction",
          loading: true,
        })
      );
      const res = await axiosInstance.delete(
        `${BASE_URL}/api/projects/touches/${id}`
      );

      dispatch(
        setLoading({
          code: "deleteTouchAction",
          loading: false,
        })
      );
      if (res.data.success) {
        toast.success("Touch deleted successfully.");
        await dispatch(fetchSectionsByProject(projectId));
        await dispatch(fetchRoomsByProject(projectId));
        await dispatch(fetchTouchesByProject(projectId));
      }

      return res;
    } catch (error) {
      dispatch(
        setLoading({
          code: "deleteTouchAction",
          loading: false,
        })
      );
      toast.error(error.response.data.message);
    }
  }
);

export const loginApiCall = createAsyncThunk(
  "authy/loginApiCall",
  async ({ token, ...data }, { rejectWithValue, dispatch }) => {
    try {
      const res = await axiosInstance.post(
        `${BASE_URL}/api/users/signin`,
        {
          ...data,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true, // Ensure cookie is set
        }
        // getHeaders()
      );
      if (res.data.success) {
        toast.success(res?.data?.message);
        // localStorage.setItem("token", res.data.token);
        if (res?.data?.user?.role == "admin") {
          window.location.href = "/admin/projects";
        } else {
          window.location.href = "/";
        }
        return res?.data;
      }

      return res;
    } catch (error) {
      return rejectWithValue(error.response.data.message || "Failed to login");
    }
  }
);

export const getUserApiCall = createAsyncThunk(
  "authy/getUserApiCall",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const res = await axiosInstance.get(
        `${BASE_URL}/api/users/get-user`
        // getHeaders()
      );
      if (res.data.success) {
        dispatch(setUser(res.data?.user));
        return res.data?.user;
      }

      return res;
    } catch (error) {
      return rejectWithValue(
        error.response.data.message || "Failed to save touches"
      );
    }
  }
);

export const getUsersApiCall = createAsyncThunk(
  "authy/getUsersApiCall",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const res = await axiosInstance.get(
        `${BASE_URL}/api/users/users`,
        {
          params: data,
        }
        // getHeaders()
      );
      if (res.data.success) {
        return res.data?.doc;
      }

      return res;
    } catch (error) {
      return rejectWithValue(
        error.response.data.message || "Failed to save touches"
      );
    }
  }
);

export const createUserApiCall = createAsyncThunk(
  "authy/createUserApiCall",
  async ({ token, ...data }, { rejectWithValue, dispatch }) => {
    try {
      const res = await axiosInstance.post(
        `${BASE_URL}/api/users/signup`,
        {
          ...data,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true, // Ensure cookie is set if needed
        }
        // getHeaders()
      );
      if (res.data.success) {
        toast.success("User created successfully.");
        // dispatch(getUsersApiCall());
        return res.data;
      }
    } catch (error) {
      return rejectWithValue(
        error.response.data.message || "Failed to save touches"
      );
    }
  }
);

export const deleteUserApiCall = createAsyncThunk(
  "authy/deleteUserApiCall",
  async (id, { rejectWithValue, dispatch }) => {
    try {
      const res = await axiosInstance.delete(
        `${BASE_URL}/api/users/users/${id}`
      );
      if (res.data.success) {
        toast.success("User deleted successfully.");
        dispatch(getUsersApiCall());
        return res.data;
      }
    } catch (error) {
      return rejectWithValue(
        error.response.data.message || "Failed to save touches"
      );
    }
  }
);

export const generatePasswordApicall = createAsyncThunk(
  "authy/generatePasswordApicall",
  async (id, { rejectWithValue, dispatch }) => {
    try {
      const res = await axiosInstance.get(
        `${BASE_URL}/api/users/generate-password/${id}`
      );
      if (res.data.success) {
        toast.success("Password generated successfully.");
        return res.data;
      }
    } catch (error) {
      return rejectWithValue(
        error.response.data.message || "Failed to save touches"
      );
    }
  }
);

export const fetchDownloaedProjectById = createAsyncThunk(
  "sections/fetchDownloaedProjectById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${BASE_URL}/api/projects/download-project/${id}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response.data.message || "Failed to fetch touche"
      );
    }
  }
);

export const fetchUserInfo = createAsyncThunk(
  "sections/fetchUserInfo",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${BASE_URL}/api/users/get-user-details-info/${id}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response.data.message || "Failed to fetch touche"
      );
    }
  }
);

export const fetchProjectById = createAsyncThunk(
  "sections/fetchProjectById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${BASE_URL}/api/projects/${id}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response.data.message || "Failed to fetch project"
      );
    }
  }
);

export const getAllProjectsApiCall = createAsyncThunk(
  "getAllProjectsApiCall",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const res = await axiosInstance.get(
        `${BASE_URL}/api/projects/all-projects`,
        {
          params: data,
        }
        // getHeaders()
      );
      if (res.data.success) {
        return res.data;
      }

      return res;
    } catch (error) {
      return rejectWithValue(
        error.response.data.message || "Failed to save touches"
      );
    }
  }
);

export const fetchProjectReportAction = createAsyncThunk(
  "fetchProjectReportAction",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const res = await axiosInstance.get(
        `${BASE_URL}/api/projects/project-report`
      );
      if (res.data.success) {
        return res.data?.report;
      }
    } catch (error) {
      return rejectWithValue(
        error.response.data.message || "Failed to get project reprot."
      );
    }
  }
);

export const editProfileApiCall = createAsyncThunk(
  "authy/editProfileApiCall",
  async ({ data }, { rejectWithValue, dispatch }) => {
    try {
      const res = await axiosInstance.patch(
        `${BASE_URL}/api/users/update-admin`,
        {
          ...data,
        }
        // getHeaders()
      );
      if (res.data.success) {
        toast.success("Profile updated successfully.");
        // dispatch(getUsersApiCall());
        return res.data;
      }
    } catch (error) {
      toast.error(error.response.data.message);
      return rejectWithValue(
        error.response.data.message || "Failed to upload profile."
      );
    }
  }
);

export const changePasswordApiCall = createAsyncThunk(
  "authy/changePasswordApiCall",
  async ({ data }, { rejectWithValue, dispatch }) => {
    try {
      const res = await axiosInstance.patch(
        `${BASE_URL}/api/users/change-password`,
        {
          ...data,
        }
      );
      if (res.data.success) {
        toast.success("Password updated successfully.");
        // dispatch(getUsersApiCall());
        return res.data;
      }
    } catch (error) {
      toast.error(error.response.data.message);
      return rejectWithValue(
        error.response.data.message || "Failed to upload password."
      );
    }
  }
);

export const createAdminUserApiCall = createAsyncThunk(
  "authy/createAdminUserApiCall",
  async ({ data }, { rejectWithValue, dispatch }) => {
    try {
      const res = await axiosInstance.patch(
        `${BASE_URL}/api/users/create-admin-user`,
        {
          ...data,
        }
      );
      if (res.data.success) {
        toast.success("Admin user created successfully.");
        // dispatch(getUsersApiCall());
        return res.data;
      }
    } catch (error) {
      toast.error(error.response.data.message);
      return rejectWithValue(
        error.response.data.message || "Failed to create admin user."
      );
    }
  }
);
